<template>
	<b-modal id="addServiceBundle" size="lg">
	  <template slot="modal-header" slot-scope="{ close }">
		<div class="container-fluid">
		  <div class="row">
			<div class="col-9 my-auto">
			  <h5 class="modal-title">Add Service Bundle</h5>
			</div>
			<div class="col-3 my-auto">
			  <div>
				<div>
				  <span>
					<a class="close">
					  <i
						class="far fa-times-circle fa-2x"
						@click="close()"
						id="closeAddServiceBundle"
						aria-label="Close"
					  ></i>
					</a>
				  </span>
				</div>
				<div></div>
			  </div>
			</div>
		  </div>
		</div>
	  </template>

	  <template slot="default">
		<div class="row text-center">
		  <div class="col-12">
			<div class="row">
			  <div class="col-12 mt-2">
				<p class="font-weight-bold text-left pl-2">Choose a Start Date</p>
			  </div>
			  <div class="col-12 text-center">
				<el-date-picker
				  v-model="pickerDate"
				  format="dd.MM.yyyy"
				  class="float-right"
				  type="date"
				  :picker-options="{disabledDate}"
				></el-date-picker>
			  </div>
			</div>
		  </div>
		  <div class="col-12">
			<div class="row">
			  <div class="col-12 mt-4">
				<p
				  class="font-weight-bold text-left pl-2"
				  v-if="!selectedBundle"
				>Search for a Service Bundle</p>
				<p
				  class="font-weight-bold text-left pl-2"
				  v-if="selectedBundle"
				>Selected Service Bundle</p>
			  </div>
			  <div class="col-12">
				<div class="input-group" v-if="!selectedBundle">
				  <input
					v-model="serviceBundleSearch"
					@keyup="search()"
					@paste="search($event)"
					type="text"
					class="form-control underline"
					name="Search for a bundle"
					placeholder="Please start typing....."
					pattern="^[A-Za-z -]+$"
				  />
				</div>
				<!-- This button only appears when a bundle has been selected -->

				<div class="d-flex align-items-end flex-column h-100" v-if="selectedBundle">
				  <template>
					<b-table
					  responsive
					  outlined
					  striped
					  :items="[selectedBundle]"
					  :fields="selectedBundleFields"
					>
					  <template slot="name" slot-scope="data">{{data.item.ServiceBundleName}}</template>
					  <template slot="description" slot-scope="data">{{data.item.ServiceBundleDescription}}</template>
					  <template slot="action">
						<a href="#" onclick="return false;" @click="clearSelection">
						  <img src="@/assets/img/remove_icon.png" />
						</a>
					  </template>
					</b-table>
				  </template>
				</div>
				<!-- This is where the search results start -->
				<div class="col no-pad bg-white sfab-search-results">
					<div
					  class="row"
					  v-if="(results && (results == 0 || !results)) &&  (serviceBundleSearch && serviceBundleSearch.length > 0)"
					>
					  <div class="col-12">
						<div class="mx-auto p-3">
						  <h5>Search Results:</h5>
						  <p class="d-inline">Sorry, no results found. Please try again.</p>
						</div>
					  </div>
					</div>
					<div
					  class="row"
					  v-else-if="results && results.length >= 1 && serviceBundleSearch.length > 2"
					>
					  <div class="col-sm">
						<div class="mx-auto p-3">
						  <template>
							<b-list-group>
							  <b-list-group-item
								href="#"
								@click="selectServiceBundle(result)"
								v-for="(result, rIndex) in results"
								:key="rIndex"
							  >{{result.Document.ServiceBundleName}}</b-list-group-item>
							</b-list-group>
						  </template>
						</div>
					  </div>
					</div>
				  </div>
				  <!-- This is where the search results end -->
			  </div>
			</div>
		  </div>
		</div>

		<!-- <span v-if="showHhNhhMapping">
		  <hr>

		  <p class="font-weight-bold text-left pl-2">HH NHH Mapping</p>

		  <div class="row">
			<div class="col">
			  <b-form-select class="form-control" name="selection" required v-model="hhNhhMapping">
				<option :value="undefined">Not Applicable</option>
				<option v-for="mapping in HHNHHMappings" :key="mapping" :value="mapping">{{mapping}}</option>
			  </b-form-select>
			</div>
		  </div>
		</span> -->
	  </template>

	  <template slot="modal-footer">
		<button
		  type="submit"
		  class="btn btn-hc float-right"
		  @click="addServiceBundle()"
		  :disabled="submitStatus == 'PENDING'"
		>Confirm</button>
	  </template>
	</b-modal>
  </template>

  <script>
import moment from 'moment';
import Vue from 'vue';
import contractsMixin from '@/mixins/contracts/contracts';
import _filters from '@/mixins/filters';

export default {
	mixins: [contractsMixin, _filters],

	data() {
		return {
			submitStatus: null,
			pickerDate: '',
			searchQuery: null,
			selectedBundle: null,
			selectedBundleComplete: null,
			hhNhhMapping: undefined,
			searchResultFields: {
				name: {
					key: 'Document.TariffName',
					label: 'Service Bundle',
					class: 'text-center',
				},
				description: {
					key: 'Document.TariffDescription',
					label: 'Description',
					class: 'text-center',
				},
			},
			selectedBundleFields: {
				name: {
					key: 'ServiceBundleName',
					label: 'Service Bundle',
					class: 'text-center',
				},
				description: {
					key: 'ServiceBundleDescription',
					label: 'Description',
					class: 'text-center',
				},
				action: {
					label: '',
					class: 'text-center',
				},
			},
		};
	},
	computed: {
		serviceBundleSearch: {
			get() {
				return this.$store.state.contracts.serviceBundleExportSearch;
			},
			set(search) {
				this.$store.commit('updateServiceBundleExportSearch', search);
			},
		},
		results() {
			let that = this;
			// Filtering returned search for service bundles that are relevant to the selected services
			return this.$_.filter(this.$store.state.serviceBundleResults, function(
				transferSearch
			) {
				return that.checkCompatibility(transferSearch.Document.ServiceTypes);
			});
		},
		activeContract: {
			get() {
				return this.$store.state.contracts.activeContract;
			},
			set(contract) {
				this.$store.commit('updateActiveContract', contract);
			},
		},
		activeBundle: {
			get() {
				return this.$store.state.contracts.activeBundle;
			},
			set(bundle) {
				this.$store.commit('updateActiveBundle', bundle);
			},
		},
		services() {
			if (!this.$store.state.contracts.services) return;

			return this.$store.state.contracts.services.filter(
				(s) => s.Contract.Id === this.activeContract.Id
			);
		},
		serviceTypes() {
			let serviceTypes = [];
			this.activeContract.Services.forEach((service) => {
				serviceTypes.push(service.ServiceType);
			});
			return this.$_.uniq(serviceTypes);
		},

		// HHNHHMappings() {
		//   return this.$config.honeycomb.HHNHHMappings;
		// },

		// showHhNhhMapping() {
		//   return (
		//     this.services.some((service) =>
		//       service.MeterPoint.MeterPointConfigs.some(
		//         (config) => config.MeasurementMethod === 'HalfHourly'
		//       )
		//     ) &&
		//     this.selectedBundleComplete &&
		//     !this.selectedBundleComplete.Products.flatMap(
		//       (j) => j.PriceVersions
		//     ).some((j) => j.PriceMatrixHh)
		//   );
		// },
	},

	watch: {
		activeContract: {
			handler(newContract) {
				if (newContract && newContract.StartDate) {
					const contractStartDate = moment(newContract.StartDate);
					const today = moment().startOf('day');
					if (contractStartDate.isBefore(today)) {
						this.pickerDate = today.format('YYYY-MM-DD');
					} else {
						this.pickerDate = newContract.StartDate;
					}
				}
			},
			immediate: true,
		},
	},

	mounted() {
		if (this.activeContract && this.activeContract.StartDate) {
			const contractStartDate = moment(this.activeContract.StartDate);
			const today = moment().startOf('day');
			if (contractStartDate.isBefore(today)) {
				this.pickerDate = today.format('YYYY-MM-DD');
			} else {
				this.pickerDate = this.activeContract.StartDate;
			}
		}
	},

	methods: {
		disabledDate(date) {
			return !moment(date).isBetween(
				this.activeContract.StartDate,
				this.activeContract.EndDate,
				'd',
				'[)'
			);
		},
		checkCompatibility(serviceBundleTypes) {
			let isCompatible = true;
			this.serviceTypes.forEach((serviceType) => {
				isCompatible = serviceBundleTypes.includes(serviceType)
					? isCompatible
					: false;
			});

			return isCompatible;
		},
		search(ev) {
			this.$store.dispatch('serviceBundleSearch', {
				Criteria: this.serviceBundleSearch,
				Index: 'Export',
			});
		},
		selectServiceBundle(item) {
			this.$store.commit('updateServiceBundleResults', {
				Results: null,
			});
			this.searchQuery = null;
			this.selectedBundle = null;
			this.selectedBundle = item.Document;
		},
		clearSelection() {
			this.selectedBundle = null;
			this.selectedBundleComplete = null;
		},
		addServiceBundle() {
			if (!this.selectedBundle) return;

			this.submitStatus = 'PENDING';
			this.$http
				.post(
					'https://' +
						Vue.config.honeycomb.queenbee.domain +
						'/api/v1/contracts/' +
						this.activeContract.Id +
						'/servicebundles',
					{
						ServiceBundleId: this.selectedBundle.ServiceBundleId,
						EffectiveFrom: moment
							.utc(moment(this.pickerDate).format('YYYY-MM-DD'))
							.format(),
					},
					{
						withCredentials: true,
					}
				)
				.then((response) => {
					this.submitStatus = 'OK';
					this.pickerDate = this.activeContract.StartDate;
					this.searchQuery = null;
					this.selectedBundle = null;
					this.selectedBundleComplete = null;
					this.$snotify.success(`Success! Service bundle added.`);
					this.$store.dispatch('getContracts');
					this.activeContract = response.data;
					// this.activeBundle = response.data.ServiceBundles.filter(bundle => bundle.Id ==
					//     this.activeBundle.Id)[0]
					document.getElementById('closeAddServiceBundle').click();
				})
				.catch((error) => {
					this.submitStatus = 'ERROR';
					if (error.response) {
						if (error.response.data.MoreInformation.length > 0) {
							const moreInformation = error.response.data.MoreInformation.find(
								(m) =>
									m.Error === 'A Not Chargeable contract may not be updated'
							);

							if (moreInformation)
								this.$snotify.error(`${moreInformation.Error}`, {
									timeout: 0,
									closeOnClick: true,
								});
							else
								error.response.data.MoreInformation.forEach((e) => {
									this.$snotify.error(`${e.Error}`, {
										timeout: 0,
										closeOnClick: true,
									});
								});
						} else {
							this.$snotify.error(`${error.response.data.UserDescription}`, {
								timeout: 0,
								closeOnClick: true,
							});
						}
					} else if (error.request) {
						this.$snotify.error(`No response recieved.`, {
							timeout: 0,
							closeOnClick: true,
						});
					} else {
						this.$snotify.error(`${error.message}`, {
							timeout: 0,
							closeOnClick: true,
						});
					}
				});
		},
	},
};
</script>
